import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from 'reducers/stateTypes';
import { isApacBusinessEntity } from 'utils/userUtils';

export const selectUserDetails = createSelector(
  (state: GlobalState) => state.user,
  (user) => user.userDetails,
);

export const selectHasCDTFrontOfficeApacAccess = createSelector(
  (state: GlobalState) => state.user,
  (user) =>
    isApacBusinessEntity(user?.userDetails?.userBusinessEntityCountryCode) &&
    user?.userDetails?.hasCDTSearchPartner &&
    user?.userDetails?.hasCDTSearchAgreement &&
    user?.userDetails?.hasCDTDownloadAgreement &&
    user?.userDetails?.hasCDTDistributeAgreement &&
    !user?.userDetails?.hasCDTSaveAgreement,
);

export const selectHasCDTBackOfficeApacAccess = createSelector(
  (state: GlobalState) => state.user,
  (user) =>
    isApacBusinessEntity(user?.userDetails?.userBusinessEntityCountryCode) &&
    user?.userDetails?.hasCDTSaveAgreement &&
    user?.userDetails?.hasCDTSearchAgreement &&
    user?.userDetails?.hasCDTDownloadAgreement &&
    !user?.userDetails?.hasCDTSearchPartner &&
    !user?.userDetails?.hasCDTDistributeAgreement,
);

// use this selectors to find the user is Apac or not based on business entity country code
export const selectIsUserApacBusinessEntity = createSelector(
  (state: GlobalState) => state.user,
  (user) => isApacBusinessEntity(user?.userDetails?.userBusinessEntityCountryCode),
);
